
  var _styles = {
  "magicmember-two-col": {
    "width": "9.36rem",
    "height": "2.18667rem",
    "display": "flex",
    "flexDirection": "row",
    "alignItems": "center",
    "justifyContent": "space-between"
  },
  "magicmember-three-col": {
    "display": "flex",
    "flexDirection": "row",
    "alignItems": "center",
    "justifyContent": "center"
  },
  "magicmember-scroll-col": {
    "display": "flex",
    "flexDirection": "row"
  }
};



  module.exports = _styles;
  